import * as React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const Flag = (props) => (
    <svg
        fill='none'
        height='30'
        viewBox='0 0 28 30'
        width='28'
        xmlns='http://www.w3.org/2000/svg'
        {...props}>
        <path
            d='M2.48759 0L2.73926 2.51669L14.7179 0.351035C16.0984 0.10145 17.3682 1.16227 17.3682 2.56514V3.94041L24.8208 2.94676C26.1697 2.76692 27.3682 3.81625 27.3682 5.17702V17.8596C27.3682 18.9543 26.5803 19.8901 25.5017 20.0767L14.0644 22.055C11.8918 22.4309 10.5312 19.7817 12.1023 18.2347L12.3693 17.9718L4.42914 19.4154L5.40302 29.1543L2.91543 29.403L0 0.248759L2.48759 0ZM14.8682 14.9764V2.86439L2.9888 5.01211L4.17958 16.9198L14.8682 14.9764ZM17.3682 15.616C17.3682 16.2188 17.1263 16.7964 16.6968 17.2193L14.4258 19.4554L24.8682 17.6492V5.46257L17.3682 6.46253V15.616Z'
            fill='currentColor'/>
    </svg>
);

export default Flag;
